module.exports = __webpack_public_path__ + "img/cashFlowBg-dark_adb15.png";